import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-105" data-mp="kzvf3jsbaucg">
      <div className="w-full border-b border-slate-200 bg-slate-100 px-4 py-1.5 text-center text-[11px] font-medium leading-snug text-slate-600 sm:px-6 sm:text-xs" data-id="element-106" data-mp="zwctykzpmr3r">
        Medical modality equipment, training, and support for chiropractic,
        rehab, and wellness practices.
      </div>
      <Header data-id="element-107" data-mp="2af76bearzm0" />
      <main className="flex-1" data-id="element-108" data-mp="2ayl7h0tu3ur">{children}</main>
      <Footer data-id="element-109" data-mp="gyjqnhl6cf5u" />
    </div>;
}